import http from "@/plugins/axios";

export default {

    addPartnerAccount(data){
        return http.post({
            url: '/admin/partner/add',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryPartnerAccount(data){
        return http.post({
            url: '/admin/partner/list/all',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryAllPartnerAccounts(){
        return http.get({
            url: '/admin/partner/query/all'
        })
    },

    updatePartnerAccount(data){
        return http.post({
            url: '/admin/partner/update',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    removePartnerAccount(data){
        return http.post({
            url: '/admin/partner/remove',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryPartnerBalanceCollect(data){
        return http.post({
            url: '/admin/partner/balance/collect',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    updatePartnerYesterdayBalance(){
        return http.get({
            url: '/admin/partner/update/yesterday/balance',
        })
    },

    getLocalTime(unixTimeStamp) {
        if (unixTimeStamp){
            unixTimeStamp = new Date(unixTimeStamp)
            let Y = unixTimeStamp.getFullYear() + '-';
            let M = (unixTimeStamp.getMonth()+1 < 10 ? '0'+(unixTimeStamp.getMonth()+1) : unixTimeStamp.getMonth()+1) + '-';
            let D = (unixTimeStamp.getDate() < 10 ? '0'+unixTimeStamp.getDate() : unixTimeStamp.getDate()) + ' ';
            let h = (unixTimeStamp.getHours() < 10 ? '0'+unixTimeStamp.getHours() : unixTimeStamp.getHours()) + ':';
            let m = (unixTimeStamp.getMinutes() < 10 ? '0'+unixTimeStamp.getMinutes() : unixTimeStamp.getMinutes()) + ':';
            let s = (unixTimeStamp.getSeconds() < 10 ? '0'+unixTimeStamp.getSeconds() : unixTimeStamp.getSeconds());
            return Y+M+D+h+m+s;
        }
    },

    partnerBalanceInfoFilter(obj, partner, markets){
        let res = obj.filter(item => (
            item.currentPrice = markets[item.coinType], item.userId = partner[0], item.partner = partner[1],
            true ? ((item.currentInterest !== 0) || (item.c2cBuy !== 0) || (item.c2cSell !== 0)
            || (item.deposit !== 0) || (item.withdrawal !== 0) || (item.coinAmount !== 0) || (item.coinFroze !== 0)
            || (item.totalAmount !== 0)) || (item.internalDeposit !== 0) || (item.internalWithdrawal !== 0)
            || (item.otcCoinAmount !== 0) || (item.otcCoinFroze !== 0) || (item.generalAvailableAmount !== 0)
            || (item.generalFrozeAmount !== 0) || (item.contractAvailableAmount !== 0 || (item.contractFrozeAmount !== 0))
            || item.generalProfit !== 0 : true)
        )
        return res
    },

    deepCopy(source) {
        let sourceCopy = source instanceof Array ? [] : {};
        for (let item in source) {
            sourceCopy[item] = typeof source[item] === 'object' ? deepCopy(source[item]) : source[item];
        }
        return sourceCopy;
    },

    export2Excel(columns, list, title) {
        require.ensure([], () => {
            const {export_json_to_excel} = require('../../../excel/Export2Excel');
            let tHeader = []
            let filterVal = []
            if (!columns) {
                return;
            }
            columns.forEach(item => {
                tHeader.push(item.title)
                filterVal.push(item.key)
            })
            const data = list.map(v => filterVal.map(j => v[j]))
            export_json_to_excel(tHeader, data, title);
        });
    },
}